import { mapValues } from 'lodash'
import * as services from '../services'

const useApi = () => mapValues(services, service => service())

export default useApi
